import { useState, useEffect } from "react";
import { loadConnectAndInitialize, StripeConnectInstance } from "@stripe/connect-js";
import useCreateConnectedAccountSession from "./use-create-connected-account-session";
import { ENV } from "common/enums/enums";
import { colors } from "colors";

export const useStripeConnect = (connectedAccountId: string, refreshTrigger?: number) => {
  const [stripeConnectInstance, setStripeConnectInstance] = useState<StripeConnectInstance | null>(null);
  const { mutateAsync: createConnectedAccountSession } = useCreateConnectedAccountSession();

  useEffect(() => {
    if (connectedAccountId) {
      const fetchClientSecret = async () => {
        const clientSecret = await createConnectedAccountSession(connectedAccountId);
        return clientSecret;
      };
      
      setStripeConnectInstance(
        loadConnectAndInitialize({
          publishableKey: ENV.REPLENISH_PUBLIC_KEY,
          fetchClientSecret,
          appearance: {
            overlays: "dialog",
            variables: {
              colorPrimary: colors.primary,
            },
          },
        })
      );
    }
  }, [connectedAccountId, refreshTrigger]);

  return stripeConnectInstance;
};

export default useStripeConnect;